import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useQuery } from 'react-apollo';
import styled, { cx } from 'react-emotion';
import { theme } from '../../Theme';
import { productPackageQuery } from './ProductPackageQuery.gql';
import PackageCard from './PackageCard';
import { useAddMultipleToCart } from '@jetshop/core/hooks/useAddMultipleToCart';
import addMultipleToCartMutation from '../../Cart/addMultipleToCart.gql';
import cartQuery from '../../Cart/CartQuery.gql';
import { DrawerTrigger } from '@jetshop/ui/Modal/Drawer/DrawerTrigger';

import t, { Intl } from '@jetshop/intl';
import { LinePrice } from './ListItemLite';

import { useFauxPricing } from './useFauxPricing';
import { ListItemRow } from './ListItemRow';
import Bindings from './Bindings';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PackageWrapper = styled('section')`
  /* padding: 2rem; */
  z-index: 1000;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;

  .title-cta {
    display: flex;
    justify-content: space-between;

    p {
      color: #000;
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration-line: underline;
      cursor: pointer;
    }
  }

  .title {
    color: #000;
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
  }

  ${theme.below.md} {
    flex-wrap: wrap;
    /* padding: 1rem; */
  }
  .large-col {
    width: calc(100% - 400px);
    padding-right: 5rem;
  }
  .large-col,
  .small-col {
    display: flex;
    flex-direction: column;
    flex: 1;
    ${theme.below.md} {
      width: 100%;
      padding: 1rem;
    }
  }
  .info-col {
    padding-top: 1rem;
    p {
      margin-bottom: 1rem;
    }
    a {
      color: ${theme.colors.primary};
    }
  }
  .link-list {
    width: 100%;

    span {
      margin-right: 2rem;
      &.active {
        font-weight: bold;
        color: ${theme.colors.primary};
      }
    }
    ${theme.below.md} {
      position: sticky;
      top: 52px;
      background: black;
      z-index: 99;
      margin-left: -1rem;
      margin-right: -1rem;
      width: calc(100% + 2rem);
      overflow-x: scroll;
      white-space: nowrap;
      span {
        white-space: nowrap;
        display: inline-block;
        padding: 1rem 0.5rem;
        padding-left: 1rem;
        color: white;
        font-size: 0.75rem;
        margin-right: 0;
        font-weight: bold;
        position: relative;
        &:first-child {
          padding-left: 0.5rem;
        }
        &:last-child {
          &::after {
            border-left: none;
          }
        }
        &::after {
          position: absolute;
          content: '';
          height: 0;
          border-top: 25px solid transparent;
          border-bottom: 25px solid transparent;
          border-left: 0.75rem solid #000;
          top: 0;
          left: 100%;
          z-index: 7;
        }
        &.active {
          background: ${theme.colors.primary};
          color: white;

          &::after {
            border-left-color: ${theme.colors.primary};
          }
        }
      }
      & + * {
        padding-top: 4rem !important;
      }
    }
  }

  .total-price {
    display: flex;
    margin-bottom: 1rem;
    justify-content: flex-end;
    div {
      margin-left: 0.5rem;
    }
    &::before {
      content: 'Paketpris:';
    }
  }

  .small-col {
    padding: 2rem 0;
    max-width: 30%;
    ${theme.below.md} {
      max-width: 100%;
      min-width: 100%;
      padding: 1rem;
    }
  }

  /* .product-list {
    scroll-snap-type: x mandatory;
    &::-webkit-scrollbar {
      display: none;
    }

    padding: 1rem 0;
    display: flex;
    overflow: auto;
    ${theme
    .below.md} {
      flex-wrap: wrap;
    }
  } */

  .product-card {
    width: 100%;
    min-width: 75%;
    flex: 1;
    display: flex;
    background-color: white;
    margin-right: 10px;
    /* margin-bottom: 10px; */
    padding: 10px;

    ${theme.below.lg} {
      min-width: 90%;
    }

    a {
      width: 100%;
      max-width: 50%;
      display: flex;
      align-items: center;
    }

    max-height: 200px;
    overflow: visible;
  }

  .product-list {
    display: flex;
    width: 100%;
    /* overflow-x: scroll; */
    overflow-x: auto;
    overflow-y: visible;
    padding: 14px 0;
    margin-bottom: 20px;
    scroll-snap-type: both mandatory;
    /* flex-wrap: wrap; */

    ::-webkit-scrollbar {
      width: 3px;
      height: 3px;
      background-color: #e3e3e3;
    }

    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 2px;
      border-radius: 2px;
      background: #c0c0c0;
    }
  }

  .packageForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    input {
      width: calc(50% - 0.5rem);
      ${theme.below.md} {
        max-width: 100%;
        min-width: 100%;
      }
    }
    textarea {
      width: 100%;
      height: 200px;
      resize: none;
    }

    input,
    textarea {
      padding: 0.5rem;
      background: #ffffff;
      border: 2px solid #f3f3f3;
      margin-bottom: 1rem;
      transition: 0.3s;
      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;

export const StyledButton = styled('button')`
  &.add-to-cart-button {
    font-size: 16px;
    height: 36px;
    line-height: 36px;
    margin: 20px 0 !important;
  }

  background: ${(props) =>
    props.active ? theme.colors.black : theme.colors.skiAccent};
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  height: 24px;
  line-height: 24px;
  max-width: 100% !important;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #ffffff;
  margin-top: 10px !important;
  svg {
    margin-right: 0.5rem;
  }
`;

const SliderWrapper = styled('div')`
  height: 100%;
  max-height: 200px;
  width: 100%;
  max-width: 100%;

  .slick-slide {
    margin-right: 10px;
  }
  .slick-track {
    display: flex;
  }
`;

const Arrow = styled('button')`
  background: black;
  border-radius: 100%;
  border: 0;
  height: 30px;
  width: 30px;
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  color: white;

  &.slick-next {
    transform: rotate(0deg);
    right: 10px;
    left: auto;
    z-index: 1;
  }
  &.slick-prev {
    transform: rotate(180deg);
    right: auto;
    left: 10px;
    z-index: 1;
  }
  &:focus {
    outline: none;
  }

  svg {
    width: 40px;
    height: auto;
  }
`;

const CustomArrow = (props) => {
  const { className, onClick } = props;
  return (
    <Arrow className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fal', 'angle-right']} />
    </Arrow>
  );
};

const ProductGroup = ({ listValues, title, ...rest }) => {
  const { data, error, loading } = useQuery(productPackageQuery, {
    variables: { articleNumbers: listValues },
    errorPolicy: 'ignore',
  });
  if (loading || error) return null;

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.1,
    slidesToScroll: 1,
    nextArrow: <CustomArrow />,
    prevArrow: <CustomArrow />,
    initialSlide: 0,
  };
  return (
    <>
      <div>
        <Bindings
          key={data?.product?.id}
          product={data?.product}
          group={title}
          {...rest}
          packageHandler={rest?.packageHandler}
          selectedPackage={rest?.selectedPackage}
        >
          Välja annan bindning?
        </Bindings>
      </div>
      {data?.products?.length > 1 ? (
        <SliderWrapper>
          <Slider {...settings}>
            {data.products.map((product) => (
              <PackageCard
                information={true}
                key={product.id}
                product={product}
                group={title}
                {...rest}
              />
            ))}
          </Slider>
        </SliderWrapper>
      ) : (
        <>
          {data.products.map((product) => (
            <PackageCard
              information={true}
              key={product.id}
              product={product}
              group={title}
              {...rest}
            />
          ))}
        </>
      )}
    </>
  );
};

const SummeryWrapper = styled('div')`
  &.hide {
    display: none;
  }

  h3 {
    color: #000;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
    margin-bottom: 10px;
  }
`;

const TotalPriceWrapper = styled('div')`
  margin-top: 10px;
  border-top: 1px solid #cccccc;

  .inner-wrapper {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .new-price {
      color: #000;
    }
  }

  p {
    font-size: 12px !important;
    font-family: Roboto !important;
    font-style: normal !important;
    line-height: 188.188% !important; /* 22.583px */
  }

  .total-price {
    display: flex;
    flex-direction: row-reverse;
    margin: 0;

    /* margin-top: 10px; */
    justify-content: flex-start;
    /* 
    > div {
      margin-top: 10px;
    } */

    ::before {
      display: none;
    }
    .price,
    .old-price,
    .new-price {
      margin-right: 0 !important;
      margin-left: 8px !important;
      font-size: 12px !important;
      font-family: Roboto !important;
      font-style: normal !important;
      line-height: 188.188% !important; /* 22.583px */
    }

    .old-price {
      font-weight: 400 !important;
    }

    .price,
    .new-price {
      font-weight: 800 !important;
    }
  }
`;

const SelectedPackage = ({
  selectedPackage,
  packageHandler,
  variantValidation,
  product,
  showNav = false,
  goToPackage,
  setActiveGroup = () => {},
}) => {
  const { calculatePrice } = useFauxPricing();
  const getPackageTotal = useMemo(() => {
    const totalDiscount = selectedPackage.reduce((acc, item) => {
      const discount = item.price.incVat - calculatePrice(item)?.incVat;
      return acc + discount;
    }, 0);

    let price = {
      price: {
        incVat:
          Object.values(selectedPackage).reduce(
            (t, { price: { incVat } }) => t + incVat,
            0
          ) - totalDiscount,
      },
      previousPrice: {
        incVat: Object.values(selectedPackage).reduce(
          (t, { previousPrice: { incVat } }) => t + incVat,
          0
        ),
      },
    };
    return price;
  }, [selectedPackage.length]);

  return (
    <>
      <SummeryWrapper className={selectedPackage?.length < 2 && 'hide'}>
        {showNav && <h3>Valda produkter</h3>}
        <h3>Summering</h3>
        {selectedPackage.map((product, i) => {
          return <ListItemRow item={product} />;
        })}
        <TotalPriceWrapper>
          <div className="inner-wrapper">
            <p>Ditt pris </p>
            <LinePrice
              className="total-price"
              price={getPackageTotal.price}
              previousPrice={getPackageTotal.previousPrice}
            />
          </div>
        </TotalPriceWrapper>
      </SummeryWrapper>
      <AddPackageToCart
        selectedPackage={selectedPackage}
        variantValidation={variantValidation}
        product={product}
      />
    </>
  );
};

export default ({ product, variant, variantValidation }) => {
  const packageGroups = product.customFields.filter((field) => {
    return field.key.indexOf('rekommenderade') > -1;
  });
  const [activeGroup, setActiveGroup] = useState(packageGroups[0] ?? null);

  const modProduct = {
    ...product,
    articleNumber: variant?.articleNumber,
    price: variant?.price,
    previousPrice: variant?.previousPrice,
    selected: variant?.values.join(' '),
  };

  const packagePlacement = useRef(null);
  const [selectedPackage, setPackage] = useState(variant ? [modProduct] : []);
  const overview = useRef();

  useEffect(() => {
    if (variant) {
      setPackage([modProduct]);
    }
  }, [variant]);

  if (packageGroups.length === 0) return null;

  const packageHandler = (product, add = true) => {
    const cleanPackage = selectedPackage.filter(
      (prod) => prod.group !== product.group
    );

    if (add) {
      setPackage([...cleanPackage, product]);
    } else {
      setPackage([...cleanPackage]);
    }
  };

  const goToPackage = () => {
    packagePlacement.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <>
      {variant && (
        <PackageWrapper innerRef={packagePlacement}>
          <div className="title-cta">
            <h3 className="title">{packageGroups[0]?.title}</h3>
          </div>
          <ProductGroup
            {...activeGroup}
            selectedPackage={selectedPackage}
            packageHandler={packageHandler}
            overview={overview}
          />
          <SelectedPackage
            goToPackage={goToPackage}
            selectedPackage={selectedPackage}
            showNav={false}
            setActiveGroup={setActiveGroup}
            packageHandler={packageHandler}
            product={product}
            variantValidation={variantValidation}
          />

          {/* <SelectedPackage
        goToPackage={goToPackage}
        selectedPackage={selectedPackage}
        showNav={true}
        setActiveGroup={setActiveGroup}
        packageHandler={packageHandler}
      /> */}

          {/* {activeGroup === 'overview' ? (
        <PackageOverview
          selectedPackage={selectedPackage}
          setPackage={setPackage}
          packageHandler={packageHandler}
        />
      ) : (
        <>
          <div className="large-col">
            <ProductGroup
              {...activeGroup}
              selectedPackage={selectedPackage}
              packageHandler={packageHandler}
              overview={overview}
            />
          </div>
          <div className="small-col" ref={overview}>
            <SelectedPackage
              goToPackage={goToPackage}
              selectedPackage={selectedPackage}
              showNav={true}
              setActiveGroup={setActiveGroup}
              packageHandler={packageHandler}
            />
          </div>
        </>
      )} */}
        </PackageWrapper>
      )}
    </>
  );
};

// const PackageOverview = ({ selectedPackage, setPackage, packageHandler }) => {
//   const { data, error, loading } = useQuery(contactInfoQuery);

//   return (
//     <>
//       <div className="small-col">
//         <h3>1. {t('Översikt över dina valda produkter')}</h3>
//         <SelectedPackage
//           selectedPackage={selectedPackage}
//           packageHandler={packageHandler}
//         />
//       </div>

//       <div className="small-col">
//         <h3>
//           2. Fyll i nedan (Lämna tomt om du vill bli kontaktad innan montering)
//         </h3>
//         <AddPackageToCart selectedPackage={selectedPackage} />
//       </div>
//       <div className="small-col">
//         <h3>3. {t('Kan vi hjälpa dig ytterligare')}</h3>
//         {loading ? (
//           <div className="info-col">Laddar...</div>
//         ) : (
//           <div
//             className="info-col"
//             dangerouslySetInnerHTML={{ __html: data.category.content }}
//           />
//         )}
//       </div>
//     </>
//   );
// };

function getItemsForAddToCart(products, comments = []) {
  let parsedComments =
    Object.values(comments).length > 0
      ? Object.entries(comments).map((comment) => {
          return { name: comment[0], value: comment[1] };
        })
      : null;

  return products.map((product, i) => ({
    ...product,
    comments: i === 0 ? parsedComments : null,
    articleNumber: product.isVariant
      ? product.variant.articleNumber
      : product.articleNumber,
  }));
}

const PackageAddToCartWrapper = styled('div')`
  margin-top: 20px;

  .show-form {
    display: block;

    ${theme.below.lg} {
      input,
      textarea {
        font-size: 16px;
      }
    }
  }
  .hide-form {
    display: none;
  }

  .form-information {
    & .show-form {
      display: block;
    }
    &.hide-form {
      display: none;
    }
    h3 {
      text-transform: none;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 6px;
    }
    p {
      font-size: 12px;
      font-weight: 400;
    }
    span {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

const AddPackageToCart = ({ selectedPackage, variantValidation, product }) => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    length: '',
    weight: '',
    message: '',
  });

  useEffect(() => {
    selectedPackage?.length >= 2 && setShowForm(true);
  }, [selectedPackage?.length]);

  const validItems = getItemsForAddToCart(selectedPackage, formData);
  const [addToCart] = useAddMultipleToCart(
    validItems,
    {
      addMultipleToCartMutation,
      cartQuery,
    },
    {
      onCompleted: () => {},
    }
  );

  const handleForm = (e) => {
    let tempObj = Object.assign({}, formData);
    tempObj[e.target.name] = e.target.value;
    setFormData(tempObj);
  };

  const submitForm = (e) => {
    e.preventDefault();

    addToCart();
  };

  return (
    <PackageAddToCartWrapper>
      <div
        className={cx('form-information', showForm ? 'show-form' : 'hide-form')}
      >
        <h3>Monteringsinformation</h3>
        {/* <p>
          Vill du addera information om dig{' '}
          <span onClick={() => setShowForm(!showForm)}>klicka här</span>.
        </p> */}
      </div>
      <form className="packageForm" onSubmit={submitForm}>
        <div className={showForm ? 'show-form' : 'hide-form'}>
          <div>
            <p style={{ fontSize: '12px', marginBottom: '10px' }}>
              För att kunna montera din bindningar korrekt behöver vi en del
              information.
            </p>
            <p style={{ fontSize: '12px', marginBottom: '10px' }}>
              <span style={{ fontWeight: '700' }}>Sulmått -</span> Anges i mm
              och står i regel på sidan av klacken på dina pjäxor. Det är inte
              samma sak som pjäxans storlek, t.ex. så har en pjäxa i storlek
              26.5 oftast ett sulmått omkring 305mm.
            </p>
            <p style={{ fontSize: '12px', marginBottom: '10px' }}>
              <span style={{ fontWeight: '700' }}>Vikt -</span>
              Detta behöver vi veta för att kunna ställa in din bindning
              korrekt. Tänk på att vi ställer in din bindning efter
              tillverkarens rekommendation, beroende på åkstil och
              användningsområde kan du behöva justera DIN-värdet för att passa
              just dina behov.
            </p>
            <p style={{ fontSize: '12px', marginBottom: '10px' }}>
              <span style={{ fontWeight: '700' }}>Övrigt -</span>
              Här fyller du i om du vill ha någon speciell monteringspunkt eller
              annan information som är bra för oss att ha vid monteringen. Du
              kan också lämna fältet blankt, då kommer vi montera skidorna efter
              tillverkarens rekommendation. Är du osäker på monteringspunkt är
              du alltid välkommen att kontakta oss med frågor.
            </p>
            {/* <p style={{ fontSize: '12px', marginBottom: '20px' }}>
              <span style={{ fontWeight: '700' }}>
                I rutan för "önskemål kring monteringspunket eller liknande"
              </span>
              <br />
              Önskemål kring monteringspunkt eller liknande. Lämnar du tomt
              monterar vi enligt tillverkarens rekommendation.
            </p> */}
          </div>
          <Intl>
            {(t) => (
              <>
                <input
                  id="length"
                  name="length"
                  type="text"
                  placeholder={t('Pjäxornas sulmått (mm)')}
                  onChange={handleForm}
                  value={formData.length}
                />
                <input
                  id="weight"
                  name="weight"
                  type="text"
                  placeholder={t('Åkarens vikt (kg)')}
                  onChange={handleForm}
                  value={formData.weight}
                />
                <textarea
                  id="message"
                  name="message"
                  type="email"
                  onChange={handleForm}
                  value={formData.message}
                  placeholder={t(
                    'Önskemål kring monteringspunkt eller liknande. Lämnar du tomt monterar vi enligt tillverkarens rekommendation.'
                  )}
                  // placeholder={t(
                  //   'Önskemål kring monteringspunkt eller liknande'
                  // )}
                ></textarea>
              </>
            )}
          </Intl>
        </div>
        <DrawerTrigger id="cart-drawer">
          {(drawer) => (
            <StyledButton
              className="add-to-cart-button"
              onClick={drawer.isOpen ? drawer.hideTarget : drawer.showTarget}
              type="submit"
              disabled={
                !(
                  product?.stockStatus?.buyable && variantValidation === 'valid'
                )
              }
            >
              {t('Add to cart')}
            </StyledButton>
          )}
        </DrawerTrigger>
      </form>
    </PackageAddToCartWrapper>
  );
};
